import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", {
        fill: "#F1CC41",
        d: "m11.496 3.402 5.649 9.886c.656 1.149-.173 2.579-1.497 2.579H4.352a1.724 1.724 0 0 1-1.497-2.58l5.649-9.885c.661-1.158 2.33-1.158 2.992 0"
      }),
      _createElementVNode("path", {
        stroke: "#FFF",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.25",
        d: "M10 12.604a.208.208 0 1 0 .002.417.208.208 0 0 0-.003-.417M10 10.1V7.183"
      })
    ], -1)
  ])))
}
export default { render: render }